const documentTypes = {
  AAFCO_NUTRITIONAL_ADEQUACY_STATEMENT: 'product.aafcoNutritionalAdequacyStatement',
  ADDITIONAL_MARKETING_TEXT: 'referential.additionalMarketingText',
  ANIMAL_ENERGY_CATEGORY: 'animal.energy-category',
  ANIMAL_ENVIRONMENT: 'animal.environment',
  ANIMAL_LIFESTAGE: 'animal.lifestage',
  ANIMAL_SIZE: 'animal.size',
  ANIMAL_SPECIFIC_NEED: 'animal.specific-need',
  ANIMAL_TERRITORY: 'animal.territory',
  ANIMAL_VET_PROGRAM: 'animal.vet-program',
  ARCHIVES_EP2_PACKAGING_ATTACHMENT: 'archives.ep2.packaging.attachment',
  ARCHIVES_EP2_PACKAGING_CREATIVE_EXCHANGE: 'archives.ep2.packaging.creativeExchange',
  ARCHIVES_EP2_PACKAGING_DEVELOPED: 'archives.ep2.packaging.developed',
  ARCHIVES_EP2_PACKAGING_GRAPHICAL_ELEMENT: 'archives.ep2.packaging.graphicalElement',
  ARCHIVES_EP2_PACKAGING_HD_LAYOUTS: 'archives.ep2.packaging.developedHD',
  ARCHIVES_EP2_PACKAGING_IMAGE: 'archives.ep2.packaging.image',
  ARCHIVES_EP2_PACKAGING_LINE: 'archives.ep2.packaging.line',
  ARCHIVES_EP2_PACKAGING_MASTER: 'archives.ep2.packaging.master',
  ARCHIVES_EP2_PACKAGING_MODEL: 'archives.ep2.packaging.model',
  ARCHIVES_EP2_PACKAGING_PICTOGRAM: 'archives.ep2.packaging.pictogram',
  ARCHIVES_EP2_PACKAGING_PLAN: 'archives.ep2.packaging.plan',
  ARCHIVES_EP2_PACKAGING_REFERENCE: 'archives.ep2.packaging.reference',
  BRAND_CONTENT_TEXT: 'brand.content.text',
  BRAND_TEXT: 'brand.text',
  BRAND: 'brand',
  COMMERCIAL_LABEL: 'product.commercialLabel',
  COMPOSITION: 'composition',
  CSBU: 'product.csbu',
  FACING_TITLE: 'product.facingTitle',
  FEEDING_GUIDE_TEXT: 'referential.feedingGuideText',
  FEEDING_INSTRUCTIONS: 'product.feedingInstructions',
  FEEDING_TABLE: 'composition.feedingTable',
  FLAVOR: 'referential.composition.flavor',
  FORMULA_FEATURES_INTENTION: 'product.claim.formulaFeaturesIntention',
  FORMULA_FEATURES: 'product.claim.formulaFeatures',
  GLOBAL_MARKETING_CONTENT: 'product.globalMarketingContent',
  GRAPHICAL_ELEMENTS_TEXTS_INTENTION: 'product.claim.graphicalElementsTextsIntention',
  GRAPHICAL_ELEMENTS_TEXTS: 'product.claim.graphicalElementsTexts',
  HEALTH_NOT_RECOMMENDED_FOR: 'health.not-recommended-for',
  HEALTH_RECOMMENDED_FOR: 'health.recommended-for',
  IP_ASSET_ATTACHMENT: 'product.ipAsset.attachment',
  IP_ASSET: 'product.ipAsset',
  LEGAL_ELEMENT_TYPOLOGY: 'referential.legalElement.typology',
  LEGAL_ELEMENT: 'product.legalElement',
  LEGAL_TEXT_HEADING: 'product.legalTextHeading',
  LEGAL_TEXT_SUB_HEADING: 'product.legalTextSubHeading',
  OTHER_LEGAL_ELEMENT: 'product.otherLegalElement',
  PACKAGING_CREATION_BRIEF: 'packaging.creation.brief',
  PACKAGING_CREATION_CREATION_LAYOUT: 'packaging.creation.creationLayout',
  PACKAGING_CREATION_CREATIVE_EXCHANGES: 'packaging.creation.creativeExchanges',
  PACKAGING_CREATION_FACING_DECLINATION: 'packaging.creation.facingDeclination',
  PACKAGING_CREATION_GRAPHIC_ELEMENTS: 'packaging.creation.graphicElements',
  PACKAGING_CREATION_IMAGE: 'packaging.creation.image',
  PACKAGING_CREATION_ORDER: 'packaging.creation.order',
  PACKAGING_CREATION_OTHER: 'packaging.creation.other',
  PACKAGING_CREATION_PICTO: 'packaging.creation.picto',
  PACKAGING_CREATION_PLANNING: 'packaging.creation.planning',
  PACKAGING_CREATION_RANGE_BOARD: 'packaging.creation.rangeBoard',
  PACKAGING_CREATION_STICKER_ELEMENTS: 'packaging.creation.stickerElements',
  PACKAGING_CREATION_STICKER_LAYOUT: 'packaging.creation.stickerLayout',
  PACKAGING_CREATION_TECHNICAL_LAYOUT: 'packaging.creation.technicalLayout',
  PACKAGING_DESIGN_BRIEF_BRIEF: 'packaging.design.brief.brief',
  PACKAGING_DESIGN_BRIEF_DEBRIEF: 'packaging.design.brief.debrief',
  PACKAGING_DESIGN_BRIEF_QUOTATION: 'packaging.design.brief.quotation',
  PACKAGING_DESIGN_CMI_BRIEF_BOARD: 'packaging.design.cmi.brief',
  PACKAGING_DESIGN_CMI_MATERIAL: 'packaging.design.cmi.material',
  PACKAGING_DESIGN_CMI_REPORT: 'packaging.design.cmi.report',
  PACKAGING_DESIGN_CONVICTION_CONVICTION: 'packaging.design.conviction.conviction',
  PACKAGING_DESIGN_DESIGN_DESIGN: 'packaging.design.design.design',
  PACKAGING_FEATURE: 'referential.packagingFeature',
  PACKAGING_ITEM_PLANNING: 'packaging.packagingItem.planning',
  PACKAGING_ITEM: 'packaging.packagingItem',
  PACKAGING_PARAMETERS_COMMERCIALIZATION_AREA: 'packaging.parameters.commercializationArea',
  PACKAGING_PARAMETERS_CONTROL_CHECKLIST_ITEM: 'packaging.parameters.controlChecklistItem',
  PACKAGING_PARAMETERS_CUTTER_GUIDE: 'packaging.parameters.cutterGuide',
  PACKAGING_PARAMETERS_DATASET: 'packaging.parameters.dataSet',
  PACKAGING_PARAMETERS_FEATURE_OPTION: 'packaging.parameters.featureOption',
  PACKAGING_PARAMETERS_FEATURE: 'packaging.parameters.feature',
  PACKAGING_PARAMETERS_FORMAT: 'packaging.parameters.format',
  PACKAGING_PARAMETERS_FOUR_COLORS_PROFILE: 'packaging.parameters.fourColorsProfile',
  PACKAGING_PARAMETERS_GRAPHIC_TEMPLATE: 'packaging.parameters.graphicTemplate',
  PACKAGING_PARAMETERS_IMAGE_TYPE: 'packaging.parameters.imageType',
  PACKAGING_PARAMETERS_INPUT_COLOR_PROFILE: 'packaging.parameters.inputColorProfile',
  PACKAGING_PARAMETERS_MACHINE: 'packaging.parameters.machine',
  PACKAGING_PARAMETERS_MARKETING_TEXTS_TYPE: 'packaging.parameters.marketingTextsType',
  PACKAGING_PARAMETERS_OUTPUT_COLOR_PROFILE: 'packaging.parameters.outputColorProfile',
  PACKAGING_PARAMETERS_PACK_TECHNO: 'packaging.parameters.packTechno',
  PACKAGING_PARAMETERS_PACK_TYPE: 'packaging.parameters.packType',
  PACKAGING_PARAMETERS_PRINTING_PROCESS_CONDITION: 'packaging.parameters.printingProcessCondition',
  PACKAGING_PARAMETERS_PRINTING_PROCESS: 'packaging.parameters.printingProcess',
  PACKAGING_PARAMETERS_PRINTING_TECH_SKILL: 'packaging.parameters.printingTechSkill',
  PACKAGING_PARAMETERS_PRINTING_TOOL: 'packaging.parameters.printingTool',
  PACKAGING_PARAMETERS_PRINTING_TOOLS_SET: 'packaging.parameters.printingToolsSet',
  PACKAGING_PARAMETERS_PROOFING_CONDITION: 'packaging.parameters.proofingCondition',
  PACKAGING_PARAMETERS_SPOT_COLORS_PROFILE: 'packaging.parameters.spotColorsProfile',
  PACKAGING_PARAMETERS_STANDARD_PROFILE: 'packaging.parameters.standardProfile',
  PACKAGING_PARAMETERS_STICKER_LAYOUT_FORMAT: 'packaging.parameters.stickerLayoutFormat',
  PACKAGING_PARAMETERS_STICKERS_SPECIFIC_TEXT: 'packaging.parameters.stickersSpecificText',
  PACKAGING_PARAMETERS_SUBSTRATE_AND_STRUCTURE: 'packaging.parameters.substrateAndStructure',
  PACKAGING_PARAMETERS_TEMPLATE_TYPE: 'packaging.parameters.templateType',
  PACKAGING_PARAMETERS_WEIGHT: 'packaging.parameters.weight',
  PACKAGING_PREPRODUCTION_BENDAY: 'packaging.preproduction.benday',
  PACKAGING_PREPRODUCTION_BRIEF: 'packaging.preproduction.brief',
  PACKAGING_PREPRODUCTION_HD_LAYOUT: 'packaging.preproduction.hdLayout',
  PACKAGING_PREPRODUCTION_MODEL: 'packaging.preproduction.model',
  PACKAGING_PREPRODUCTION_ORDER: 'packaging.preproduction.order',
  PACKAGING_PREPRODUCTION_OTHER: 'packaging.preproduction.other',
  PACKAGING_PREPRODUCTION_PLANNING: 'packaging.preproduction.planning',
  PACKAGING_PREPRODUCTION_PROFILED_IMAGE: 'packaging.preproduction.profiledImage',
  PACKAGING_PRODUCTION_ARTWORK: 'packaging.production.artwork',
  PACKAGING_PRODUCTION_BRIEF: 'packaging.production.brief',
  PACKAGING_PRODUCTION_LOCALIZED_STICKER: 'packaging.production.localizedSticker',
  PACKAGING_PRODUCTION_MATRIX: 'packaging.production.matrix',
  PACKAGING_PRODUCTION_ORDER: 'packaging.production.order',
  PACKAGING_PRODUCTION_OTHER: 'packaging.production.other',
  PACKAGING_PRODUCTION_PLANNING: 'packaging.production.planning',
  PACKAGING_PRODUCTION_PRINTING_TOOLS_CONFIGURATION: 'packaging.production.printingToolsConfiguration',
  PACKAGING_PRODUCTION_REPRO: 'packaging.production.repro',
  PARNUTS: 'product.parnuts',
  PRODUCT_BENEFITS_INTENTION: 'product.claim.productBenefitsIntention',
  PRODUCT_BENEFITS: 'product.claim.productBenefits',
  PRODUCT_HERO_IMAGE: 'product.heroImage',
  PRODUCT_LEGAL_TEXT_MASTER: 'product.legalText.master',
  PRODUCT_LEGAL_TEXT_ORDER: 'product.legalText.order',
  PRODUCT_LEGAL_TEXT_TRANSLATION: 'product.legalText.translation',
  PRODUCT_MARKETING_TEXT_MASTER: 'product.marketingText.master',
  PRODUCT_MARKETING_TEXT_ORDER: 'product.marketingText.order',
  PRODUCT_MARKETING_TEXT_TRANSLATION: 'product.marketingText.translation',
  PRODUCT_MEDIA: 'product.media',
  PRODUCT_SKU: 'product.sku',
  PRODUCT_TEXT_TRANSLATION_LEGAL_ORDER_HEADER: 'product.textTranslation.legal.orderHeader',
  PRODUCT_TEXT_TRANSLATION_MARKETING_ORDER_HEADER: 'product.textTranslation.marketing.orderHeader',
  PRODUCT_TEXT_TRANSLATION: 'product.textTranslation.translation',
  PRODUCT: 'product',
  RANGE_CONTENT_TEXT: 'range.content.text',
  RANGE_TEXT: 'range.text',
  RANGE: 'range',
  REASON: 'referential.composition.reason',
  REGIONAL_MARKETING_CONTENT: 'product.regionalMarketingContent',
  SENSITIVITIES_INTENTION: 'product.claim.sensitivitiesIntention',
  SENSITIVITIES: 'product.claim.sensitivities'
} as const;

export default documentTypes;
